const currentLang = document.documentElement.lang.toUpperCase();
const STOREFRONT_API_URL = `https://${Shopify.shop}/api/2023-10/graphql.json`;
const STOREFRONT_API_ACCESS_TOKEN = '5ca2d0e6d3c32cb5443ee05e75844d24';

export const fetchStoreMetaobjects = async () => {
  // GraphQL query to fetch store metaobjects
  const query = `
    query @inContext(language: ${currentLang}) {
      metaobjects(type: "store",first: 250) {
        nodes {
          ...on Metaobject {
            id
            handle
            name: field(key: "name") { value }
            store_number: field(key: "bentley_store_number") { value }
            location_id: field(key: "location_id") { value }
            address: field(key: "address") { value }
            phone: field(key: "phone") { value }
            longitude: field(key: "longitude") { value }
            latitude: field(key: "latitude") { value }
            monday_hours: field(key: "monday_hours") { value }
            tuesday_hours: field(key: "tuesday_hours") { value }
            wednesday_hours: field(key: "wednesday_hours") { value }
            thursday_hours: field(key: "thursday_hours") { value }
            friday_hours: field(key: "friday_hours") { value }
            saturday_hours: field(key: "saturday_hours") { value }
            sunday_hours: field(key: "sunday_hours") { value }
          }
        }
      }
    }
  `;

  const response = await fetch(STOREFRONT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_API_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query }),
  });

  const data = await response.json();

  // mapping data to a more usable format
  const stores = data.data.metaobjects.nodes.map((store) => {
    return {
      id: store.id,
      handle: store.handle,
      name: store.name.value,
      store_number: store.store_number?.value,
      location_id: store.location_id?.value,
      address: store.address?.value,
      phone: store.phone?.value,
      longitude: store.longitude?.value,
      latitude: store.latitude?.value,
      monday_hours: store.monday_hours?.value,
      tuesday_hours: store.tuesday_hours?.value,
      wednesday_hours: store.wednesday_hours?.value,
      thursday_hours: store.thursday_hours?.value,
      friday_hours: store.friday_hours?.value,
      saturday_hours: store.saturday_hours?.value,
      sunday_hours: store.sunday_hours?.value,
    };
  });

  return stores;
}

// Get distance between two points in kilometers
export const getDistance = (lat1, lat2, lon1, lon2) => {
  // Convert to radians
  lon1 =  lon1 * Math.PI / 180;
  lon2 = lon2 * Math.PI / 180;
  lat1 = lat1 * Math.PI / 180;
  lat2 = lat2 * Math.PI / 180;

  // Haversine formula
  let dlon = lon2 - lon1;
  let dlat = lat2 - lat1;
  let a = Math.pow(Math.sin(dlat / 2), 2)
  + Math.cos(lat1) * Math.cos(lat2)
  * Math.pow(Math.sin(dlon / 2),2);

  let c = 2 * Math.asin(Math.sqrt(a));

  // Radius of earth in kilometers. Use 3956 for miles
  let r = 6371;

  return(c * r);
}
